"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rem = rem;
exports.convertDashesToCamelCase = convertDashesToCamelCase;
exports.ifWrappable = ifWrappable;
exports.checkGlobals = checkGlobals;
exports.trimSearchQuery = trimSearchQuery;

var _index = require("../index");

/**
 * Converts PX to REMs due to standart rem size
 * @param {int} size in px
 * @returns {string} Size in rem
 */
function rem(size) {
  var _getConfig = (0, _index.getConfig)(),
      UI_REM_SIZE = _getConfig.UI_REM_SIZE;

  return size / UI_REM_SIZE + 'rem';
}
/**
 * Converts text-with-dashes into camelCase
 * @param {string} text text-with-dashes to replace
 * @returns {string} camelCase text
 */


function convertDashesToCamelCase(text) {
  return text.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}
/**
 * Check whether text contain any long no-wrappable parts
 * @param {string} text - Text to check
 * @param {int} maxLength=15
 * @returns {boolean} Wrappable or not
 */


function ifWrappable(text) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
  var result = true;
  text.split(' ').forEach(function (item) {
    if (item.length > maxLength) result = false;
  });
  return result;
}
/**
 * Check for global variables (made for wrapper like cordova)
 * @param {array} globals Array of names to check in global (window) scope
 * @returns {boolean}
 */


function checkGlobals(globals) {
  var result = true;
  globals.forEach(function (gl) {
    if (typeof window[gl] === 'undefined') result = false;
  });
  return result;
}
/**
 * Replace special symbols in search query string
 * @param {string} query Search query to replace
 * @returns {string} text without special symbols
 */


function trimSearchQuery(query) {
  return query.replace(/[^-._'`’ A-Za-z0-9]+/g, '');
}